import { Link } from 'react-router-dom';
import { movies } from '@/mocks/movies';
import MovieCard from '@/components/base/MovieCard';

export default function FeaturedSection() {
  const featuredMovies = movies.filter((m) => m.featured);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              精选高分影视，品质保证
            </p>
          </div>
          <Link
            to="/category/all"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5"
          data-product-shop
        >
          {featuredMovies.map((movie) => (
            <MovieCard
              key={movie.id}
              id={movie.id}
              title={movie.title}
              cover={movie.cover}
              rating={movie.rating}
              year={movie.year}
              tags={movie.tags}
            />
          ))}
        </div>

        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-1 text-sm text-primary-600 font-medium"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}